var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlusCircleAzure = function SvgPlusCircleAzure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.27 8.496a.667.667 0 0 0-.667-.667H9.165V5.391a.667.667 0 0 0-1.333 0V7.83H5.394a.667.667 0 0 0 0 1.334h2.438V11.6a.667.667 0 0 0 1.333 0V9.163h2.438a.667.667 0 0 0 .667-.667Z",
    fill: "#1C7CE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5.5a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8Zm0 14.667A6.666 6.666 0 1 1 15.167 8.5 6.674 6.674 0 0 1 8.5 15.167Z",
    fill: "#1C7CE5"
  })));
};
export default SvgPlusCircleAzure;